export const HOTELS_LOB_FAVOURITES = 'aa-hotel';
export const THUMBNAIL_SIZE = '350px';
export const HERO_SIZE = '1000px';
export const HOTELS_LIST_BATCH_SIZE = 30;
export const HOTELS_LIST_MINIMUM_SIZE = 6;
export const HOTELS_LIST_SHOW_MORE_BUTTON_PAGE_NUMBER_THRESH_HOLD = 2;
export const ENABLE_SORTING_HOTEL_LIST_AT_CLIENT = true;
export const COUNTRY_CODE_HEADER = 'x-cdn-geo-country';
export const TRIP_INFO_KEY = 'tripInfo';
export const IGNORE_CACHE = 'ignoreCache=1';
export const ATTR_DEDICATED_FOR_COVID = {
  id: 1073744973,
  messageId: 'common.dedicatedForCovidHealthWorkers',
  type: 'warning',
};

export const GA_LABELS = {
  bookersInfo: 'bookers info',
  bookersInfoDone: 'bookers info done',
  apiFailed: 'API Fail',
  apiFailedSearchAgain: 'API Fail - Search Again',
  priceChange: 'Price Change',
  selectNewCombo: 'Select new combo',
  selectNewRoom: 'Select new room',
  combo: 'combo',
  searchAgain: 'Search Again',
  hotelNotAvailable: 'Hotel Not Available',
  hotelReviewsPagination: 'view review|',
  hotelReviewView: 'read reviews',
  hotelViewReviews: 'view reviews',

  givenName: 'givenName',
  surname: 'surname',
  email: 'email',
  mobileNo: 'mobileNo',
  dob: 'dob',

  oneField: 'One Field',
  allFields: 'All Fields',
  multipleFields: 'Multiple Fields',

  overall: 'Overall',
  summary: 'Summary',
  booker: 'Booker',
  logged_in: 'loggedin',
  non_loggedin: 'non-loggedin',
  lob: 'Hotels SA',

  manageMyBooking: 'hotel sa - manage my booking',
  keepBooking: 'keep booking',
  loginModal: 'loginModal',
};

export const GA_EVENTS = {
  trackEventNoEcommerce: 'trackEventNoEcommerce',
  productImpressions: 'productImpressions',
  productClick: 'productClick',
  productDetails: 'productDetails',
  addToCart: 'addToCart',
  tap: 'tap',
};

export const GA_CATEGORIES = {
  guest_detail: 'Guest Detail',
  guest_detail_heatmap: 'Hotels SA|Guest Details heatmap',
  hotelSAGuestDetailError: 'Hotel SA | GuestDetailsError',
  hotelSABooking: 'hotel booking status',
  hotelConfirmationHeatmap: 'Hotel Confirmation Heatmap',
  hotelBookingConfirmationError: 'Hotel SA | BookingConfirmationError',
  hotelBookingDetailsError: 'Hotel SA | BookingDetailsError',
  heatmap: 'Hotel|Room Select Heatmap',
  roomImpression: 'Room Impression',
  roomSelect: 'Room Select',
  heatmapv2: 'Hotel|Room Select heatmap',
  uhf_login: 'Hotel|uhf login',
  hotelSelectHeatmap: 'Hotel|Hotel Select heatmap',
  hotelRoomFilterSelect: 'Hotels SA|Room Select|filter',
};

export const GA_ACTIONS = {
  click: 'click',
  view: 'View',

  fieldLeftEmpty: 'fieldLeftEmpty',
  alphabetsError: 'alphabetsError',
  maxLengthError: 'maxLengthError',
  numberError: 'numberError',
  mobileError: 'mobileError',
  emailError: 'emailError',
};

export const GA_VALUES = {
  events: GA_EVENTS,
  categories: GA_CATEGORIES,
  actions: GA_ACTIONS,
  labels: GA_LABELS,
};

export const GUEST_REQUIRED_FIELDS = {
  BOOKER_FORM: ['familyName', 'givenName', 'email', 'mobileNumber'],
  TRAVELER_FORM: ['familyName', 'givenName'],
  FIELD_NAME_LABELS: {
    familyName: 'surname',
    givenName: 'givenName',
    email: 'email',
    mobileNumber: 'mobileNo',
  },
};

export const GA_BOOKING_STATUS_MAPPING = {
  payment_failed_temp: 1,
  payment_pending: 2,
  payment_failed: 3,
  inventory_pending: 4,
  refund_pending: 5,
  booking_failed: 6,
  confirmed: 7,
};

export const GA_BOOKING_PENALTY_TYPE = {
  None: 3,
  Partial: 2,
  Full: 1,
};

export const CHECKOUT_TIMEOUT = 10;
export const SUPPORTED_CURRENCIES = [
  'AUD',
  'BDT',
  'BND',
  'CNY',
  'EUR',
  'GBP',
  'HKD',
  'INR',
  'MOP',
  'MYR',
  'NZD',
  'PHP',
  'SAR',
  'SGD',
  'THB',
  'TWD',
  'USD',
  'IDR',
  'JPY',
  'KRW',
  'VND',
];
export const SUPPORTED_LOCALE = [
  'en-gb',
  'th-th',
  'ms-my',
  'id-id',
  'ja-jp',
  'ko-kr',
  'vi-vn',
  'zh-cn',
  'zh-hk',
  'zh-tw',
];

export const SchHotelConfig = [
  { currency: SUPPORTED_CURRENCIES },
  { locale: SUPPORTED_LOCALE },
  { checkoutTimeout: CHECKOUT_TIMEOUT },
];

export const getSchHotelConfig = supportedCurrencies => {
  return [
    { currency: supportedCurrencies },
    { locale: SUPPORTED_LOCALE },
    { checkoutTimeout: CHECKOUT_TIMEOUT },
  ];
};
